import * as h2Api from '../../h2Api'
import * as actions from '../../actions/admin/adminUserActions.js'
import { ACKNOWLEDGEMENT_LOADED, ADMIN_USER_TUTORIAL_1 } from '../../actions/tutorials'

const initialState = {
  cards: {
    resultCount: 0,
    status: 'loading',
    lastError: null,
    value: [],
    backlogged: false,
    renderTrigger: 0
  },
  search: {
    criteria: {
      selections: [],
      users: [],
      schools: [],
      graduation: [],
      sort: 1
    },
    recentGroups: [],
    schools: [],
    suggestions: [],
    history: []
  },
  showTutorial: false,
  accessOptions: [],
  schools: []
}
const reducers = (state = initialState, action) => {
  switch (action.type) {
    case ACKNOWLEDGEMENT_LOADED:
      if (action.key === ADMIN_USER_TUTORIAL_1) {
        return {
          ...state,
          showTutorial:
            action.details.acknowledgement &&
            action.details.acknowledgement.dateAcknowledged == null
        }
      }

      return state

    case actions.GROUP_DELETE:
      return {
        ...state,
        search: {
          ...state.search,
          recentGroups: state.search.recentGroups.filter(
            f => f.id !== action.removal.groupId
          ),
          criteria: {
            ...state.search.criteria,
            selections: state.search.criteria.selections.filter(
              f =>
                f.kind !== 'GROUP' ||
                (f.kind === 'GROUP' && f.id !== action.removal.groupId)
            )
          }
        }
      }

    case actions.SEARCH_ACCESS_OPTIONS: {
      return {
        ...state,
        accessOptions: action.options
      }
    }

    case actions.CHANGE_CRITERIA: {
      return {
        ...state,
        search: {
          ...state.search,
          criteria: {
            ...state.search.criteria,
            ...action.change
          }
        }
      }
    }

    case actions.ADD_SEARCH_HISTORY: {
      if (state.search.history.includes(action.historyItem)) {
        return state
      }

      return {
        ...state,
        search: {
          ...state.search,
          history: [...state.search.history, action.historyItem]
        }
      }
    }

    case actions.LOAD_SCHOOLS: {
      if (action.restCall.status === h2Api.REST_CALL_STATUS.RECEIVED) {
        return {
          ...state,
          search: {
            ...state.search,
            schools: action.restCall.result
          }
        }
      }

      return state
    }

    case actions.SEARCH: {
      if (action.restCall.status === h2Api.REST_CALL_STATUS.RECEIVED) {
        const renderTrigger = state.cards.renderTrigger + 1
        const createdDateMap = action.restCall.result.createdDates

        return {
          ...state,
          cards: {
            ...state.cards,
            status: 'ok',
            resultCount: action.restCall.result.resultCount,
            value: action.restCall.result.userList.map(u => ({
              ...u,
              ...createdDateMap[u.id]
            })),
            renderTrigger
          }
        }
      }

      return {
        ...state,
        cards: {
          ...state.cards,
          status:
            action.restCall.status === h2Api.REST_CALL_STATUS.ERROR
              ? 'failed'
              : 'loading',
          lastError: 'Failed to search users'
        }
      }
    }

    case actions.REFRESH_LIST: {
      const renderTrigger = state.cards.renderTrigger + 1

      return {
        ...state,
        cards: {
          ...state.cards,
          renderTrigger
        }
      }
    }

    case actions.LOAD_MORE: {
      //If this load request doesn't match up with the number of users we currently have, ignore it
      if (action.restCall.status === h2Api.REST_CALL_STATUS.RECEIVED) {
        const renderTrigger = state.cards.renderTrigger + 1
        const createdDateMap = action.restCall.result.createdDates
        const currentUserCount = state.cards.value.length

        if (action.startIndex !== currentUserCount) {
          console.log(
            'currentUserCount',
            currentUserCount,
            "doesn't line up with action.startIndex",
            action.startIndex
          )

          return {
            ...state,
            cards: {
              ...state.cards,
              status: 'ok',
              backlogged: false
            }
          }
        }

        //console.log("Adding", action.restCall.result.userList.length, "additional users starting at", currentUserCount);
        const newValues = action.restCall.result.userList.map(u => {
          return {
            ...u,
            ...createdDateMap[u.id]
          }
        })

        return {
          ...state,
          cards: {
            ...state.cards,
            backlogged: false,
            status: 'ok',
            value: [...state.cards.value, ...newValues],
            renderTrigger
          }
        }
      }

      return {
        ...state,
        cards: {
          ...state.cards,
          status:
            action.restCall.status === h2Api.REST_CALL_STATUS.ERROR
              ? 'failed'
              : 'loading',
          lastError: 'Failed to search users'
        }
      }
    }

    case actions.LOAD_BACKLOG: {
      return {
        ...state,
        cards: {
          ...state.cards,
          backlogged: true
        }
      }
    }

    case actions.UPDATE_SELECTIONS: {
      const selections = action.selections

      return {
        ...state,
        search: {
          ...state.search,
          criteria: {
            ...state.search.criteria,
            selections
          }
        }
      }
    }

    case actions.ADD_SELECTION: {
      const chosen = action.selection
      let selections = state.search.criteria.selections
      const exists = !!selections.find(sel => {
        return sel.kind === chosen.kind && sel.id === chosen.id
      })
      let recentGroups = state.search.recentGroups
      const groupInHistory = !!recentGroups.find(sel => sel.id === chosen.id)

      if (chosen.kind === 'GROUP' && !groupInHistory) {
        recentGroups = [chosen, ...recentGroups].slice(0, 5)
      }

      if (!exists) {
        selections = [...selections, chosen]
      }

      return {
        ...state,
        search: {
          ...state.search,
          recentGroups,
          criteria: {
            ...state.search.criteria,
            selections
          }
        }
      }
    }

    case actions.REMOVE_SELECTION: {
      const chosen = action.selection
      const selections = state.search.criteria.selections.filter(ele => {
        //console.log("Checking selection", chosen, "against", ele);
        return ele.kind !== chosen.kind || ele.id !== chosen.id
      })

      return {
        ...state,
        search: {
          ...state.search,
          criteria: {
            ...state.search.criteria,
            selections
          }
        }
      }
    }

    case actions.REMOVE_SCHOOL: {
      const chosen = action.selection
      const schools = state.search.criteria.schools.filter(ele => {
        //console.log("Checking selection", chosen.id, "against", ele.id, ele.id !== chosen.id);
        return ele.id !== chosen.id
      })
      const newState = {
        ...state,
        search: {
          ...state.search,
          criteria: {
            ...state.search.criteria,
            schools
          }
        }
      }

      return newState
    }

    case actions.REMOVE_GRADE: {
      const chosen = action.selection
      const graduation = state.search.criteria.graduation.filter(ele => {
        //console.log("Checking selection", chosen, "against", ele, ele !== chosen);
        return ele !== chosen
      })
      const newState = {
        ...state,
        search: {
          ...state.search,
          criteria: {
            ...state.search.criteria,
            graduation
          }
        }
      }

      return newState
    }

    case actions.REMOVE_ROLE:
      const chosen = action.selection
      const users = state.search.criteria.users.filter(ele => {
        //console.log("Checking selection", chosen, "against", ele, ele !== chosen);
        return ele !== chosen
      })
      const newState = {
        ...state,
        search: {
          ...state.search,
          criteria: {
            ...state.search.criteria,
            users
          }
        }
      }

      return newState

    case actions.CLEAR_SEARCH_SUGGESTIONS: {
      return {
        ...state,
        search: {
          ...state.search,
          suggestions: []
        }
      }
    }

    case actions.SEARCH_SUGGESTIONS: {
      if (action.restCall.status === h2Api.REST_CALL_STATUS.RECEIVED) {
        return {
          ...state,
          search: {
            ...state.search,
            suggestions: action.restCall.result
          }
        }
      }

      return state
    }

    case actions.GROUP_SEARCH: {
      //console.log("Received group search results", action);
      /*
       * Transform results so they are usable as a datasource
       */
      let results = null

      if (action.restCall.status === h2Api.REST_CALL_STATUS.RECEIVED) {
        results = action.restCall.result.map(r => ({ description: r.name, group: r }))
      } else {
        results = []
      }

      //console.log("Results are", results);
      /*
       * Update the appropriate user card
       */
      const users = state.cards.value.map(user => {
        if (user.id === action.criteria.userId) {
          console.log('Found user with id', action.criteria.userId)

          return {
            ...user,
            groupSearchResults: results
          }
        }

        return user
      })

      return {
        ...state,
        cards: {
          ...state.cards,
          value: users
        }
      }
    }

    case actions.GROUP_ADD_MEMBER: {
      if (action.restCall.status === h2Api.REST_CALL_STATUS.RECEIVED) {
        const renderTrigger = state.cards.renderTrigger + 1
        const userId = action.restCall.result.userId
        const groupId = action.restCall.result.groupId
        const groupName = action.assignment.groupName
        //console.log("Adding group", action);
        const users = state.cards.value.map(user => {
          //console.log("Checking", user, "against", userId);
          if (user.id === userId) {
            //console.log("Found user to add", groupId, "to");
            return {
              ...user,
              groups: [...user.groups, { id: groupId, name: groupName }]
            }
          }

          return user
        })

        return {
          ...state,
          cards: {
            ...state.cards,
            value: users,
            renderTrigger
          }
        }
      }

      return state
    }

    case actions.GROUP_REMOVE_MEMBER: {
      if (action.restCall.status === h2Api.REST_CALL_STATUS.RECEIVED) {
        const userId = action.removal.userId
        const groupId = action.removal.groupId
        const renderTrigger = state.cards.renderTrigger + 1
        const users = state.cards.value.map(user => {
          if (user.id === userId) {
            //console.log("Found user to remove", groupId, "from");
            return {
              ...user,
              groups: user.groups.filter(group => {
                return group.id !== groupId
              })
            }
          }

          return user
        })

        return {
          ...state,
          cards: {
            ...state.cards,
            value: users,
            renderTrigger
          }
        }
      }

      return state
    }

    case actions.GROUP_ADD_OWNER: {
      if (action.restCall.status === h2Api.REST_CALL_STATUS.RECEIVED) {
        const userId = action.restCall.result.userId
        const groupId = action.restCall.result.groupId
        const groupName = action.assignment.groupName
        const renderTrigger = state.cards.renderTrigger + 1
        //console.log("Adding group", action);
        const users = state.cards.value.map(user => {
          //console.log("Checking", user, "against", userId);
          if (user.id === userId) {
            //console.log("Found user to add", groupId, "to");
            return {
              ...user,
              groupsOwned: [...user.groupsOwned, { id: groupId, name: groupName }]
            }
          }

          return user
        })

        return {
          ...state,
          cards: {
            ...state.cards,
            value: users,
            renderTrigger
          }
        }
      }

      return state
    }

    case actions.GROUP_REMOVE_OWNER: {
      if (action.restCall.status === h2Api.REST_CALL_STATUS.RECEIVED) {
        const userId = action.removal.userId
        const groupId = action.removal.groupId
        const renderTrigger = state.cards.renderTrigger + 1
        const users = state.cards.value.map(user => {
          if (user.id === userId) {
            //console.log("Found user to remove", groupId, "from");
            return {
              ...user,
              groupsOwned: user.groupsOwned.filter(group => {
                return group.id !== groupId
              })
            }
          }

          return user
        })

        return {
          ...state,
          cards: {
            ...state.cards,
            value: users,
            renderTrigger
          }
        }
      }

      return state
    }

    default:
      return state
  }
}

export default reducers
